module.exports = __webpack_public_path__ + "img/horizontal_6_1_8019.1abb0e1b.png";